import { IOfferScopeStatusLang, OFFER_SCOPE_STATUS_LANG_KEY } from './interface.IOfferScopeStatusLang'
import { IOfferScopeCapTypeLang, OFFER_SCOPE_CAP_TYPE_LANG_KEY } from './interface.IOfferScopeCapTypeLang'
import { IHistoryIsEmptyLang, HISTORY_IS_EMPTY_LANG_KEY } from './interface.IHistoryIsEmptyLang'
import { IDatePickerModeLang, DATE_PICKER_MODE_LANG_KEY } from './interface.IDatePickerModeLang'
import { IPostbackStatusLang, POSTBACK_STATUS_LANG_KEY } from './interface.IPostbackStatusLang'
import { IPostbackCurrencyLang, POSTBACK_CURRENCY_LANG_KEY } from './interface.IPostbackCurrencyLang'
import { IRevenueAgencyFakeTypeLang, REVENUE_AGENCY_FAKE_TYPE_LANG_KEY } from './interface.IRevenueAgencyFakeTypeLang'
import { IAccountIsActiveLang, ACCOUNT_IS_ACTIVE_LANG_KEY } from './interface.IAccountIsActiveLang'
import { IRoleExtraIsBuyerLang, ROLE_EXTRA_IS_BUYER_LANG_KEY } from './interface.IRoleExtraIsBuyerLang'
import { IRoleIsSystemLang, ROLE_IS_SYSTEM_LANG_KEY } from './interface.IRoleIsSystemLang'
import { IRoleAccessIsAnyLang, ROLE_ACCESS_IS_ANY_LANG_KEY } from './interface.IRoleAccessIsAnyLang'
import {
	IOfferSpendByAccountViewLang,
	OFFER_SPEND_BY_ACCOUNT_VIEW_LANG_KEY
} from './interface.IOfferSpendByAccountViewLang'
import {
	IOfferSpendByOfferViewLang,
	OFFER_SPEND_BY_OFFER_VIEW_LANG_KEY
} from './interface.IOfferSpendByOfferViewLang'
import {
	IOfferSpendByOfferScopeViewLang,
	OFFER_SPEND_BY_OFFER_SCOPE_VIEW_LANG_KEY
} from './interface.IOfferSpendByOfferScopeViewLang'
import { IPercentIsEmptyLang, PERCENT_IS_EMPTY_LANG_KEY } from './interface.IPercentIsEmptyLang'
import { IAccountIsFiredLang, ACCOUNT_IS_FIRED_LANG_KEY } from './interface.IAccountIsFiredLang'

export * from './interface.IOfferScopeStatusLang'
export * from './interface.IOfferScopeCapTypeLang'
export * from './interface.IHistoryIsEmptyLang'
export * from './interface.IPercentIsEmptyLang'
export * from './interface.IDatePickerModeLang'
export * from './interface.IPostbackStatusLang'
export * from './interface.IPostbackCurrencyLang'
export * from './interface.IRevenueAgencyFakeTypeLang'
export * from './interface.IAccountIsActiveLang'
export * from './interface.IAccountIsFiredLang'
export * from './interface.IRoleExtraIsBuyerLang'
export * from './interface.IRoleIsSystemLang'
export * from './interface.IRoleAccessIsAnyLang'
export * from './interface.IOfferSpendByAccountViewLang'
export * from './interface.IOfferSpendByOfferViewLang'
export * from './interface.IOfferSpendByOfferScopeViewLang'

export type IEnumAllLang =
	& IOfferScopeStatusLang
	& IOfferScopeCapTypeLang
	& IHistoryIsEmptyLang
	& IPercentIsEmptyLang
	& IDatePickerModeLang
	& IPostbackStatusLang
	& IPostbackCurrencyLang
	& IRevenueAgencyFakeTypeLang
	& IAccountIsActiveLang
	& IAccountIsFiredLang
	& IRoleExtraIsBuyerLang
	& IRoleIsSystemLang
	& IRoleAccessIsAnyLang
	& IOfferSpendByAccountViewLang
	& IOfferSpendByOfferViewLang
	& IOfferSpendByOfferScopeViewLang

export const ENUM_ALL_LANG_KEY: IEnumAllLang = {
	...OFFER_SCOPE_CAP_TYPE_LANG_KEY,
	...OFFER_SCOPE_STATUS_LANG_KEY,
	...HISTORY_IS_EMPTY_LANG_KEY,
	...PERCENT_IS_EMPTY_LANG_KEY,
	...DATE_PICKER_MODE_LANG_KEY,
	...POSTBACK_STATUS_LANG_KEY,
	...POSTBACK_CURRENCY_LANG_KEY,
	...REVENUE_AGENCY_FAKE_TYPE_LANG_KEY,
	...ACCOUNT_IS_ACTIVE_LANG_KEY,
	...ACCOUNT_IS_FIRED_LANG_KEY,
	...ROLE_EXTRA_IS_BUYER_LANG_KEY,
	...ROLE_IS_SYSTEM_LANG_KEY,
	...ROLE_ACCESS_IS_ANY_LANG_KEY,
	...OFFER_SPEND_BY_ACCOUNT_VIEW_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_VIEW_LANG_KEY,
	...OFFER_SPEND_BY_OFFER_SCOPE_VIEW_LANG_KEY
}
